import Input from '@jetbrains/ring-ui/components/input/input'
import classNames from 'classnames'
import * as React from 'react'

import styles from './FilterInput.css'

const TIMEOUT_MS = 500
type Props = {
  filterText: string
  changeFilterText: (arg0: string) => unknown
  legacy?: boolean
  placeholder?: string | null | undefined
  className?: string | null | undefined
  timeout?: number
  'data-test-build-tests'?: string
}

function FilterInput({
  legacy,
  placeholder,
  filterText,
  changeFilterText,
  className,
  timeout,
  ...restProps
}: Props) {
  const changeFilterTextTimeout = React.useRef<number>()
  const [value, setValue] = React.useState(filterText)
  React.useEffect(() => {
    clearTimeout(changeFilterTextTimeout.current)
    changeFilterTextTimeout.current = window.setTimeout(() => {
      if (value !== filterText) {
        changeFilterText(value)
      }
    }, timeout ?? TIMEOUT_MS)
    return () => clearTimeout(changeFilterTextTimeout.current)
  }, [changeFilterTextTimeout, value, changeFilterText, timeout, filterText])
  React.useEffect(() => {
    setValue(filterText)
  }, [filterText])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.currentTarget.value)
  }

  return (
    <Input
      {...restProps}
      className={classNames(styles.filterInput, className)}
      type="search"
      placeholder={placeholder ?? 'Filter'}
      value={value}
      onClear={() => setValue('')}
      onChange={handleInputChange}
    />
  )
}

export default React.memo<Props>(FilterInput)
